import { render, staticRenderFns } from "./IconTime.vue?vue&type=template&id=2a8c6b69"
import script from "./IconTime.vue?vue&type=script&setup=true&lang=ts"
export * from "./IconTime.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports